// extracted by mini-css-extract-plugin
export default {"link":"wLa_hCG7"};